/* global s */
'use strict';

class MobileRechargeV4 {
	constructor(options) {
		// console.log('MobileRechargeV4(%o)', options);
		this.defaults = {
			operators_per_row: 4,
			mr_hero_max_operators: 6,
			target_hero_max_operators: 6,
			tracking_params: {
				banners: {}
			},
			operators_back_btn_text: s.it('RECHARGE_ANOTHER_OPERATOR'),
			add_tello_as_operator: [],
			add_custom_operators: [],
		};

		this.fields = {
			holder: null,
			form: null,
			country: null,
			operator_holder: null,
			operator_content: null,
			operator_options_content: null,
			operator_banner_holder: null,
			operator_banner_content: null,
			account_fields_holder: null,
			account_fields_content: null,
			nickname_fields_holder: null,
			amount_holder: null,
			amount_content: null,
			amount_custom_range_input: null,
			amount_banner_holder: null,
			amount_banner_content: null,
			submit_holder: null,
			submit_message_holder: null
		};
		this.cache = {};
		this.fetcher = {};

		this.fields = Object.assign(this.fields, options.fields);
		this.options = Object.assign(this.defaults, options.defaults);
		this.base_url = options.base_url;
		this.location = options.location;
		this.add_tello_as_operator = options.add_tello_as_operator;
		this.add_custom_operators = options.add_custom_operators;
		this.state = {
			'country': {},
			'operator': {},
			'supplier_operator_fields': [],
			'account_fields': {
				'keys': [], // keep a collection of field_keys; used for validating the account fields
				'types': [], // keep a collection of types; used for the notification section and for building the hidden notification form inputs
			},
			'amount': {},
			'notifications': {
				'email': {},
				'sms': {}
			},
			'sms_notify': {},
			'email_notify': {},
			'nickname': {}
		};
		this.state = Object.assign(this.state, options.state);

		this.pageEvents();
	}

	pageEvents() {
		const _this = this;
		// Bind click events for dynamic content
		document.addEventListener('click', (event) => {
			const choose_another_operator = event.target.closest('#choose_another_operator');
			if (choose_another_operator) {
				for (let operator of _this.fields.operator_content.querySelectorAll('.operator')) {
					operator.classList.remove('d-none', 'active');
				}
				choose_another_operator.classList.remove('active', 'on_active_display_block');
				_this.emptyElement(_this.fields.submit_message_holder);

				const new_url = `${_this.base_url}/${encodeURIComponent(_this.state.country.name)}`;
				window.history.replaceState(_this.state, 'Title', s.url(new_url, {}));

				this.resetFields();

				this.state.operator = {};
				this.state.operator.id = null;
				this.state.supplier_operator_fields = [];
				this.state.account_fields.types = [];
				this.state.account_fields.keys = [];
				this.state.amount = null;
			}
		});
	}

	/**
	 * Gets the operator groups for a specific country and returns them.
	 * @param {String} 	country_code
	 * @return {Object}
	 */
	changeCountry(country_code) {
		// console.log('MobileRecharge changeCountry(%o)', country_code, this.state);
		this.emptyElement(this.fields.operator_content);
		this.emptyElement(this.fields.operator_options_content);
		this.hideElement(this.fields.operator_banner_holder);
		this.emptyElement(this.fields.operator_banner_content);
		this.hideElement(this.fields.account_fields_holder);
		this.emptyElement(this.fields.account_fields_content);
		this.showElement(this.fields.operator_holder);

		if (this.fields.operator_holder.querySelector('.spinner')) {
			this.fields.operator_holder.querySelector('.spinner').classList.remove('d-none');
		}

		return new Promise((resolve, reject) => {
			this.state.country.code = country_code;
			this.state.operator = {};
			this.state.supplier_operator_fields = {};
			this.state.amount = {};

			if (this.fields.country) {
				this.fields.country.value = this.state.country.name;
			}

			// stop unnecessary requests
			if (this.fetcher.get_distinct_operators) {
				this.fetcher.get_distinct_operators.abort();
			}

			// used on KC
			if (this.state.country.name) {
				s.track.dataLayerPush({
					'event': 'gtm_remarketing',
					'destination': this.state.country.name,
					'dynx_pagetype': 'searchresults'
				});
			}

			if (this.cache[this.state.country.code]) {
				resolve({
					'state': this.state,
					'operator_groups': this.cache[this.state.country.code]
				});
			} else {
				if (this.state.country.code === '') {
					resolve({
						'state': this.state,
						'operator_groups': []
					});
				} else {
					const form_data = new FormData();
					form_data.append('action', 'get_distinct_operators_v4');
					form_data.append('country_code', this.state.country.code);
					form_data.append('product_type', 'mobile_recharge');

					if (this.options.banner_promo_code) {
						form_data.append('banner_promo_code', this.options.banner_promo_code);
					}

					this.fetcher.get_distinct_operators = s.common.fetcher(
						s.url('/buy/mobile_recharge_checks'),
						{
							method: 'post',
							body: form_data
						}
					);

					this.fetcher.get_distinct_operators.ready
						.then((operator_groups) => {
							resolve({
								'state': this.state,
								'operator_groups': operator_groups
							});
						})
						.catch(error => {
							if (error.name !== 'AbortError') {
								reject({
									'state': this.state,
									'operator_groups': [],
									'status': false,
									'err': error
								});
							}
						});
				}
			}
		})
			.then((response) => {
				if (response.operator_groups !== undefined) {
					this.cache[this.state.country.code] = response.operator_groups;

					if (this.fields.operator_holder.querySelector('.spinner')) {
						this.fields.operator_holder.querySelector('.spinner').classList.add('d-none');
					}
				}
				return response;
			})
			.catch((error) => {
				this.hideElement(this.fields.operator_holder);
				throw error;
			});
	}

	/**
	 * Gets details for a specific operator.
	 * @param {String} operator_id
	 * @return {Object}
	 */
	changeOperator(operator_id) {
		// console.log('MobileRecharge changeOperator(%o)', operator_id, this.state);
		return new Promise((resolve) => {
			const operator = this.getOperatorDetails(operator_id);
			const supplier_operator_fields = operator.supplier_operator_fields;

			this.state.operator = operator;
			this.state.supplier_operator_fields = supplier_operator_fields;
			this.state.account_fields.types = [];
			this.state.account_fields.keys = [];
			this.state.amount = null;

			clearTimeout(s.options.page_timers.account_field_show_error);

			if (supplier_operator_fields.length) {
				supplier_operator_fields.forEach(field => {
					let oldFieldValue;
					if (this.state.account_fields[field.field_key]?.value) {
						oldFieldValue = this.state.account_fields[field.field_key].value;
					}

					this.state.account_fields[field.field_key] = field;
					this.state.account_fields.keys.push(field.field_key);
					this.state.account_fields.types.push(field.type);

					if (oldFieldValue) {
						this.state.account_fields[field.field_key].value = oldFieldValue;
					}
				});
			}

			if (typeof this.options.tracking_params.banners[operator_id] !== 'undefined') {
				if (this.options.tracking_params.banners[operator_id].banner_type && this.options.tracking_params.banners[operator_id].banner_content) {
					s.track.event(
						`MR ${this.options.tracking_params.banners[operator_id].banner_type} Banner`,
						'Impressions',
						`${this.options.tracking_params.banners[operator_id].banner_type} ${this.options.tracking_params.banners[operator_id].banner_content}`
					);
				}
			}

			resolve({
				'state': this.state,
				'operator': operator
			});
		})
			.then((response) => {
				this.displayActiveOperators(operator_id);

				if (this.location === 'buy_mr' || this.location === 'send_page') {
					this.showOperatorBanners(response.operator);
					this.createAccountFieldsSection();
				}

				return response;
			})
			.catch((error) => {
				throw error;
			});
	}

	/**
	 * Handles the change account field event.
	 * @param {String} 	account_field_key
	 * @param {String} 	account_field_value
	 */
	changeAccountField(account_field_key, account_field_value) {
		// console.log('MobileRecharge changeAccountField key: (%o), value: (%o)', account_field_key, account_field_value);
		const field_input = this.fields.account_fields_content.querySelector(`input[data-account-field-key='${account_field_key}']`);

		if (!field_input) {
			return new Promise(() => {})
				.then(() => {})
				.catch(() => {});
		}

		const field_input_parent = field_input.closest('.field-wrapper');
		const field_checkmark = field_input_parent.querySelector('.field-checkmark');
		const field_mask = field_input_parent.querySelector('.field-mask');
		const field_error = field_input_parent.querySelector('.field-error');
		const field = this.getSupplierOperatorFieldsDetails(account_field_key);

		let set_input_value = account_field_value;

		return new Promise((resolve, reject) => {
			let field_check_regex = field.regex;
			let field_check_value = set_input_value;

			switch (field.type) {
				case 'phone':
					if (account_field_value) {
						account_field_value = this.stripNonNumericCharacters(account_field_value);
					}

					set_input_value = account_field_value.replace(field.prefix, '');
					const strip_phone_prefix = this.sanitizePhoneNumber(field.prefix);

					const full_phone_number = strip_phone_prefix + set_input_value;
					this.updatePhoneMask(field_mask, full_phone_number);

					field_check_value = full_phone_number;
					break;

				case 'string':
					if (account_field_value) {
						account_field_value = this.sanitizeByRegex(account_field_value, field_check_regex);
					}

					set_input_value = account_field_value;

					this.updateStringMask(field_mask, account_field_value);

					field_check_value = account_field_value;
					break;

				case 'email':
				case 'nauta':
					set_input_value = this.sanitizeEmailAddress(account_field_value);
					field_check_value = set_input_value;
					break;
			}

			this.state.account_fields[account_field_key].value = set_input_value;
			field_input.value = set_input_value;

			const setFieldValid = () => {
				field_input.setAttribute('aria-invalid', 'false');
				resolve({
					'status': true,
					'field': field,
					'state': this.state
				});
			};

			const setFieldInvalid = () => {
				field_input.setAttribute('aria-invalid', 'true');
				reject({
					'status': false,
					'field': field,
					'state': this.state
				});
			};

			const validateField = () => {
				if (field_check_value && new RegExp(field_check_regex).test(field_check_value)) {
					setFieldValid();
				} else {
					setFieldInvalid();
				}
			}

			if (parseInt(field.required)) {
				validateField()
			} else {
				if (field_input.value) {
					validateField();
				} else {
					setFieldValid();
				}
			}
		})
			.then((response) => {
				clearTimeout(s.options.page_timers.account_field_show_error);
				this.showElement(field_checkmark);
				this.emptyElement(field_error);
				this.hideElement(field_error);

				this.emptyElement(this.fields.submit_message_holder);

				/* Dynamic Remarketing - used on MR */
				if (typeof response.state.country.name !== 'undefined' && typeof response.state.operator.name !== 'undefined') {
					s.track.dataLayerPush({
						'event': 'gtm_dynamic_remarketing',
						'google_tag_params': {
							'ecomm_prodid': this.state.country.name,
							'ecomm_pagetype': 'product',
							'ecomm_pcat': this.state.operator.name
						}
					});
				}

				return response;
			})
			.catch((response) => {
				clearTimeout(s.options.page_timers.account_field_show_error);

				if (field_error && field.error_message) {
					field_error.innerText = s.it(field.error_message);
				}

				if (field_input.value) {
					s.options.page_timers.account_field_show_error = setTimeout(() => {
						this.hideElement(field_checkmark);
						this.showElement(field_error);
						s.options.page_timers.account_field_show_error = null;
					}, 500);
				} else {
					this.hideElement(field_checkmark);
					this.hideElement(field_error);
				}

				throw response;
			});
	}

	/**
	 * Handles display of operators in a specific country.
	 * @param {Object} 	operator_groups
	 */
	updateCountryOperators(operator_groups) {
		// console.log('MobileRecharge updateCountryOperators(%o)', operator_groups);
		this.sortByPriority(operator_groups);

		if (this.fields.operator_banner_content) {
			this.hideElement(this.fields.operator_banner_holder);
			this.fields.operator_banner_content.innerHTML = '';
		}

		let _i = 1;
		let fake_operator_index = null;
		const keys = Object.keys(operator_groups);

		if (this.add_tello_as_operator && this.add_tello_as_operator.position) {
			if (keys.length >= this.add_tello_as_operator.position) {
				fake_operator_index = this.add_tello_as_operator.position;
			} else {
				fake_operator_index = keys.length;
			}
		}

		for (let group_name in operator_groups) {
			if (fake_operator_index && _i === fake_operator_index && this.state.country.code === 'US') {
				let operator_element = document.createElement('div');
				const operator_col_size = Math.floor(12 / this.options.operators_per_row);
				operator_element.classList.add('col-6', 'col-md-4', `col-lg-${operator_col_size}`, 'fake', 'operator');
				let operator_button = `
					<a href='${s.h(this.add_tello_as_operator.link)}' 
						class='d-flex flex-column align-items-center justify-content-center mb-20 operator_button' 
						target='_blank' 
						aria-label='${s.h(this.add_tello_as_operator.name)}' 
						data-country='${s.h(this.add_tello_as_operator.name)}' 
						tabindex='0'
					>
						<div class='banner-icons-holder d-flex'>
							<svg class='banner-icon ml-5' data-banner_type='_index_mr_offer'>
								<use xlink:href='#svg_icon-label--promo-new'></use>
							</svg>
						</div>
						<div class='operator-logo d-flex flex-grow-1 justify-content-center align-items-center' style='min-height: 58px;'>
							<img src='${s.url(this.add_tello_as_operator.image_src)}' alt='${s.h(this.add_tello_as_operator.name)}' class='img-fluid'>
						</div>
					</a>`;
				const node = document.createRange().createContextualFragment(operator_button); // convert string to Node element
				operator_element.appendChild(node);
				this.fields.operator_content.append(operator_element);
			}

			if (operator_groups.hasOwnProperty(group_name)) {
				let group_details = operator_groups[group_name];
				let operator_element = document.createElement('div');
				let operator_button;
				let operator_banners = [];
				let banner_icons = document.createElement('div');
				let operator_logo = document.createElement('img');
				let icon_already_added = false;
				let show_more_operators_box = false;
				let display_max_operators = null;

				if (this.location === 'hero') {
					if (this.add_tello_as_operator && this.state.country.code === 'US') {
						display_max_operators = this.options.mr_hero_max_operators - 1;
					} else {
						display_max_operators = this.options.mr_hero_max_operators;
					}
				}
				if (this.location === 'hero_target') {
					display_max_operators = this.options.target_hero_max_operators;
				}
				if (display_max_operators && _i > display_max_operators) {
					show_more_operators_box = true;
				}

				banner_icons.classList.add('banner-icons-holder', 'd-flex');

				const operator_span_size = Math.floor(12 / this.options.operators_per_row);
				operator_element.classList.add('col-6', 'col-md-4', `col-lg-${operator_span_size}`, 'operator');

				operator_logo.src = s.url(`/images/operators/${encodeURIComponent(group_details.logo)}.jpg`);
				operator_logo.alt = s.h(group_details.name ? group_details.name : group_details.logo);
				operator_logo.classList.add('img-fluid');

				if (group_details.operators.length > 1) {
					operator_button = document.createElement('div');
					operator_button.classList.add('d-flex', 'flex-column', 'justify-content-center', 'align-items-center');
					this.sortByPriority(group_details.operators);

					if ('group' in group_details) {
						operator_button.setAttribute('data-operator-group', group_details.group);
						operator_button.setAttribute('tabindex', '0');
					}

					group_details.operators.forEach((operator) => {
						operator_banners = this.getOperatorBanners(operator);
						operator_banners.forEach((banner) => {
							if (banner.icon) {
								icon_already_added = banner_icons.innerHTML && banner_icons.innerHTML.indexOf(banner.icon.innerHTML) > 0;
								if (!icon_already_added) {
									banner_icons.appendChild(banner.icon);
								}
							}
						});
					});
				} else {
					let operator = group_details.operators[0];

					operator_button = document.createElement('button');
					operator_button.value = operator.id;
					operator_button.type = 'button';
					operator_button.setAttribute('aria-label', `Operator: ${operator.name}`);
					operator_button.setAttribute('data-country', operator.country_name);
					operator_button.setAttribute('data-operator', operator.name);
					operator_button.setAttribute('data-operator-group', operator.group);
					operator_button.setAttribute('data-operator-type', operator.operator_type);
					operator_button.setAttribute('tabindex', '0');

					operator_banners = this.getOperatorBanners(operator);
					operator_banners.forEach(banner => {
						if (banner.icon) {
							icon_already_added = banner_icons.innerHTML && banner_icons.innerHTML.indexOf(banner.icon.innerHTML) > 0;
							if (!icon_already_added) {
								banner_icons.appendChild(banner.icon);
							}
						}
					});
				}

				operator_button.classList.add('mb-20', 'operator_button');
				operator_button.appendChild(banner_icons);
				operator_button.appendChild(operator_logo);

				if (show_more_operators_box) {
					operator_element.classList.add('d-none');
				}

				if (display_max_operators && _i > display_max_operators - 1 && operator_groups.length > display_max_operators) {
					// Only Show the "see more operators" button in case we have more than the predefined number of
					// displayed operators on a certain section
				} else {
					operator_element.appendChild(operator_button);
					this.fields.operator_content.append(operator_element);
				}

				// show_more_operators_box
				if (show_more_operators_box && _i === operator_groups.length) {
					let selected_country = '';
					if (s.options.preferred_destination) {
						selected_country = s.options.preferred_destination;
					}

					if (typeof this.state.country.name === 'string') {
						selected_country = this.state.country.name;
					}
					const col_more = document.createElement('div');
					col_more.classList.add('col-6', 'col-md-4', 'col-lg-4', 'more_operators');

					const more_group = document.createElement('a');
					more_group.classList.add(
						'd-flex', 'flex-column', 'align-items-center', 'justify-content-center',
						'text-center', 'text-decoration-none', 'border', 'border-white', 'cursor-pointer',
						'px-10', 'mb-20'
					);
					more_group.setAttribute('href', s.url(`${this.base_url}/${selected_country}`));
					more_group.style.height = '110px';

					const more_text = document.createElement('div');
					more_text.classList.add('color-white', 'fs-16-fixed', 'text-center');
					more_text.innerText = s.it('MR_HOMEPAGE_MORE_OPERATORS');

					const more_arrow = document.createElement('div');
					more_arrow.innerHTML = s.svg(
						'icon-arrow--xx-large',
						'0 0 58 68',
						['color-white'],
						{'width': '68px', 'height': '58px'},
						'',
						'',
						''
					);

					more_group.append(more_text);
					more_group.append(more_arrow);
					col_more.append(more_group);
					this.fields.operator_content.append(col_more);
				}

				_i++;
			}
		}
		if (this.state.country.code === 'CU' && this.add_custom_operators && this.add_custom_operators.length) {
			for (let operator of this.add_custom_operators) {
				let operator_element = document.createElement('div');
				const operator_col_size = Math.floor(12 / this.options.operators_per_row);
				operator_element.classList.add('col-6', 'col-md-4', `col-lg-${operator_col_size}`, 'fake', 'operator');
				const operator_image = s.url(`/images/operators/${encodeURIComponent(operator.image_src)}.jpg`);
				let operator_button = `
				<a href='${s.h(operator.link)}' 
					class='d-flex flex-column align-items-center justify-content-center mb-20 operator_button' 
					target='_self' 
					aria-label='${s.h(operator.name)}' 
					data-country='${s.h(operator.name)}' 
					data-operator='${s.h(operator.name)}' 
					tabindex='0'
				>
					<div class='operator-logo d-flex flex-grow-1 justify-content-center align-items-center' style='min-height: 58px;'>
						<img src='${operator_image}' alt='${s.h(operator.name)}' class='img-fluid'>
					</div>
				</a>`;
				const node = document.createRange().createContextualFragment(operator_button);
				operator_element.appendChild(node);
				this.fields.operator_content.append(operator_element);
			}
		}

		this.showElement(this.fields.operator_holder);
	}

	/**
	 * Returns the operator details for a specific operator
	 * @param {String} operator_id
	 * @return {Object}
	 */
	getOperatorDetails(operator_id) {
		// console.log('MobileRecharge getOperatorDetails: ', operator_id);
		let operator_groups = this.cache[this.state.country.code];
		let operator = null;

		for (let group_name in operator_groups) {
			if (operator_groups.hasOwnProperty(group_name)) {
				let group_details = operator_groups[group_name];

				for (let group_name in group_details.operators) {
					if (group_details.operators.hasOwnProperty(group_name)) {
						let _operator = group_details.operators[group_name];

						if (_operator.id === operator_id) {
							operator = _operator;
							break;
						}
					}
				}
				if (operator) {
					return operator;
				}
			}
		}
	}

	/**
	 * Returns the supplier operator fields details for a specific field key
	 * @param {String} key
	 * @return {Object}
	 */
	getSupplierOperatorFieldsDetails(key) {
		if (this.state.supplier_operator_fields.length) {
			return this.state.supplier_operator_fields.find((field) => field.field_key === key);
		}
	}

	/**
	 * Handles display of operators in an operator group.
	 * @param {Object} 	operator_group
	 */
	updateOperatorGroup(operator_group) {
		// console.log('MobileRecharge updateOperatorGroup(%o)', operator_group);
		const _this = this;

		if (operator_group.operators.length === 1) {
			return;
		}

		const operators = operator_group.operators;
		_this.sortByPriority(operators);
		_this.resetFields();
		_this.fields.operator_options_content.innerHTML = '';

		if (_this.fields.operator_banner_content) {
			_this.hideElement(_this.fields.operator_banner_holder);
			_this.fields.operator_banner_content.innerHTML = '';
		}

		let _i = 1;
		const group_details = operator_group;
		for (let operator_index in operators) {
			if (!operators.hasOwnProperty(operator_index)) {
				continue;
			}
			let operator = operators[operator_index];

			let group;
			let operator_banners = [];
			let banner_icons = document.createElement('div');
			let col = document.createElement('div');
			let group_logo_holder = document.createElement('div');
			let group_logo = document.createElement('img');
			let icon_already_added = false;
			banner_icons.classList.add('banner-icons-holder', 'd-flex');

			const operator_span_size = Math.floor(12 / _this.defaults.operators_per_row);
			col.classList.add('col-6', 'col-md-4', `col-lg-${operator_span_size}`, 'operator');

			group_logo.classList.add('img-fluid');
			group_logo.src = s.url(`/images/operators/${encodeURIComponent(group_details.logo)}.jpg`);
			group_logo.alt = s.h(group_details.name ? group_details.name : group_details.logo);

			group_logo_holder.classList.add('operator-logo', 'd-flex', 'flex-grow-1', 'justify-content-center', 'align-items-center');
			group_logo_holder.style.minHeight = '58px';
			group_logo_holder.appendChild(group_logo);

			group = document.createElement('button');
			group.value = operator.id;
			group.type = 'button';

			const operator_label = document.createElement('div');
			operator_label.innerHTML = operator.name.replace(operator.group, '').trim();
			operator_label.classList.add('operator_label');

			operator_banners = _this.getOperatorBanners(operator);
			operator_banners.forEach(banner => {
				if (banner.icon) {
					icon_already_added = banner_icons.innerHTML && banner_icons.innerHTML.indexOf(banner.icon.innerHTML) > 0;
					if (!icon_already_added) {
						banner_icons.appendChild(banner.icon);
					}
				}
				if (_this.fields.operator_banner_content) {
					_this.showElement(_this.fields.operator_banner_holder);
					_this.fields.operator_banner_content.appendChild(banner.content);
				}
			});

			group.appendChild(banner_icons);
			group.appendChild(group_logo_holder);
			group.appendChild(operator_label);
			group.setAttribute('aria-label', 'Operator: ' + operator.name);
			group.setAttribute('data-country', operator.name);
			group.classList.add('operator_button', 'd-flex', 'flex-column', 'justify-content-center', 'align-items-center', 'p-0', 'mb-20');

			col.appendChild(group);
			_this.fields.operator_options_content.append(col);

			// Back to operator groups
			if (_i === operators.length) {
				const col_back = document.createElement('div');
				col_back.classList.add('col-6', 'col-md-4', 'col-lg-3', 'operators_back');
				col_back.setAttribute('tabindex', '0');

				const back_group = document.createElement('div');
				back_group.classList.add(
					'd-flex', 'flex-column', 'align-items-center', 'justify-content-center',
					'text-center', 'text-decoration-none', 'border', 'border-white', 'cursor-pointer',
					'px-10', 'mb-20'
				);
				back_group.style.height = '110px';

				const back_text = document.createElement('div');
				back_text.classList.add('back_text', 'fs-16-fixed');
				back_text.innerText = _this.defaults.operators_back_btn_text;

				let svg_color_class = 'color-white';

				switch (_this.location) {
					case 'hero':
					case 'hero_target':
						col_back.classList.remove('col-lg-3');
						col_back.classList.add('col-lg-4');
						break;
					case 'buy_mr':
						back_group.classList.remove('border-white');
						back_text.classList.add('btn-link');
						svg_color_class = 'color-primary';
						break;
				}

				const back_arrow = document.createElement('div');
				back_arrow.innerHTML = s.svg(
					'icon-arrow--x-large',
					'0 0 36 41',
					[svg_color_class],
					{'height': '36px', 'width': '41px'},
					'',
					'',
					''
				);
				back_arrow.style.transform = 'rotate(180deg)'; // create arrow left

				back_group.append(back_text);
				back_group.append(back_arrow);
				col_back.append(back_group);
				_this.fields.operator_options_content.append(col_back);

				col_back.addEventListener('click', function () {
					const operator_content_operators = _this.fields.operator_content.querySelectorAll('.operator');
					operator_content_operators.forEach(element => {
						element.classList.remove('active', 'inactive');
					});
					_this.showElement(_this.fields.operator_content);
					_this.hideElement(_this.fields.operator_options_content);
					_this.resetFields();

					let new_url;
					if (_this.location === 'send_page') {
						let country = ''
						Object.values(_this.cache).some((operator_groups) => {
							if (Array.isArray(operator_groups)) {
								const first_operator = operator_groups[0].operators;
								if (first_operator[0].country_name) {
									country = first_operator[0].country_name;
								}
							}
							return Boolean(country);
						});

						if (_this.state.operator) {
							new_url = `${_this.base_url}/${encodeURIComponent(_this.state.operator.country || country)}`;
						} else {
							new_url = `${_this.base_url}/${encodeURIComponent(country)}`;
						}
					} else {
						new_url = `${_this.base_url}/${encodeURIComponent(_this.state.country.name)}`;
					}

					if (_this.location === 'buy_mr' || _this.location === 'send_page') {
						operator_content_operators.forEach(element => {
							element.classList.remove('d-none');
						});

						window.history.replaceState(_this.state, 'Title', s.url(new_url, {}));
					}

					if (_this.location === 'hero' || _this.location === 'send_page') {
						_this.fields.submit_button.setAttribute('href', s.url(new_url));
					}
				});
			}
			_i++;
		}

		_this.showElement(_this.fields.operator_options_content);
	}

	/**
	 * Creates the back button for operator group.
	 */
	createOperatorGroupBackButton() {
		const col_back = document.createElement('div');
		col_back.setAttribute('id', 'choose_another_operator');
		col_back.classList.add('operators_back', 'col-6', 'col-md-4', 'col-lg-3', 'd-none', 'd-md-none');

		const back_group = document.createElement('div');
		back_group.classList.add(
			'd-flex', 'flex-column', 'align-items-center', 'justify-content-center',
			'text-center', 'text-decoration-none', 'border', 'border-white', 'cursor-pointer',
			'px-10', 'mb-20');
		back_group.style.height = '110px';

		const back_text = document.createElement('div');
		back_text.classList.add('back_text', 'fs-16-fixed');
		back_text.innerText = s.it('RECHARGE_ANOTHER_OPERATOR');

		let svg_color_class = 'color-white';

		switch (this.location) {
			case 'buy_mr':
				back_group.classList.remove('border-white');
				back_text.classList.add('btn-link');
				svg_color_class = 'color-primary';
				break;
		}

		const back_arrow = document.createElement('div');
		back_arrow.innerHTML = s.svg(
			'icon-arrow--x-large',
			'0 0 36 41',
			[svg_color_class],
			{'height': '36px', 'width': '41px'},
			'',
			'',
			''
		);
		back_arrow.style.transform = 'rotate(180deg)'; // create arrow left

		back_group.append(back_text);
		back_group.append(back_arrow);
		col_back.append(back_group);
		this.fields.operator_content.append(col_back);
	}

	/**
	 * Triggers events for preselected operators.
	 * @param {String} 	group_name
	 * @param {String} 	operator_id
	 */
	preselectOperatorGroup(group_name = '', operator_id = '') {
		if (group_name && this.fields.operator_holder) {
			const op_group_el = this.fields.operator_holder.querySelector(`div.operator_button[data-operator-group='${group_name}']`);
			const op_el = this.fields.operator_holder.querySelector(`.operator_button[data-operator-group='${group_name}']`);
			if (op_group_el) {
				op_group_el.click();
			} else if (op_el) {
				// only 1 operator in the group
				op_el.click();
			}
		}

		if (operator_id && this.fields.operator_options_content) {
			const op_el = this.fields.operator_options_content.querySelector(`button.operator_button[value='${operator_id}']`);
			if (op_el) {
				op_el.click();
			}
		}
	}

	/**
	 * Find operator in operator groups by operator group name.
	 * @param {Object} 	operator_groups
	 * @param {String} 	group_name
	 * @return {Object}
	 */
	findOperatorGroup(operator_groups, group_name) {
		try {
			let operator_group_index = false;
			operator_groups.filter((operator_group, og_index) => {
				if (operator_group.group === group_name) {
					operator_group_index = og_index;
					return true;
				}
			});
			return operator_groups[operator_group_index];
		} catch (error) {
			return false;
		}
	}

	/**
	 * Find operator in operator groups by operator id.
	 * @param {Object} 	operator_groups
	 * @param {String} 	operator_id
	 * @return {Object} {operator}
	 */
	findOperatorGroupByOperatorID(operator_groups, operator_id) {
		try {
			let operator_group_index = false;
			operator_groups.filter((operator_group, og_index) => {
				return operator_group.operators.filter((operator) => {
					if (parseInt(operator.id) === parseInt(operator_id)) {
						operator_group_index = og_index
						return true;
					}
				})
			})
			return operator_groups[operator_group_index];
		} catch (error) {
			return false;
		}
	}

	/**
	 * Displays the active operator and sets inactive for the other operators.
	 * @param {String} 	operator_id
	 */
	displayActiveOperators(operator_id) {
		const operators = this.fields.operator_content.querySelectorAll('.operator');
		if (this.location === 'buy_mr' || this.location === 'send_page') {
			operators.forEach(element => {
				element.classList.remove('active');
				element.classList.add('inactive', 'd-none', 'd-md-block');
			});

			if (operators.length >= 3) {
				for (let element of this.fields.operator_content.querySelectorAll('.operator:not(.active)')) {
					element.classList.add('d-none');
				}
				const choose_another_operator = this.fields.operator_content.querySelector('#choose_another_operator');
				if (choose_another_operator) {
					choose_another_operator.classList.remove('active', 'on_active_display_block');
				}
			} else {
				for (let element of this.fields.operator_content.querySelectorAll('.operator')) {
					element.classList.remove('d-none');
				}
			}
		} else {
			operators.forEach(element => {
				element.classList.remove('active');
				element.classList.add('inactive');
			});
		}

		const group_select = this.fields.operator_holder.querySelector(`.operator select option[value='${s.h(operator_id)}']`);

		if (group_select && group_select.length) {
			const closest_group_select = group_select.closest('select');
			const closest_group_operator = group_select.closest('.operator');

			closest_group_select.value = operator_id;

			if (this.location === 'buy_mr' || this.location === 'send_page') {
				closest_group_operator.classList.remove('inactive', 'd-none', 'd-md-block');
				closest_group_operator.classList.add('active');
			} else {
				closest_group_operator.classList.remove('inactive');
				closest_group_operator.classList.add('active');
			}
		} else {
			const operator_button = this.fields.operator_holder.querySelector(`.operator_button[value='${s.h(operator_id)}']`);

			if (operator_button) {
				const closest_operator_button = operator_button.closest('.operator');
				if (closest_operator_button) {
					if (this.location === 'buy_mr' || this.location === 'send_page') {
						closest_operator_button.classList.remove('inactive', 'd-none', 'd-md-block');
						closest_operator_button.classList.add('active');
					} else {
						closest_operator_button.classList.remove('inactive');
						closest_operator_button.classList.add('active');
					}
				}
			}
		}
	}

	/**
	 * Displays the operator banners.
	 * @param {Object} 	operator
	 */
	showOperatorBanners(operator) {
		// console.log('MobileRecharge showOperatorBanners(%o)', operator);
		if (this.fields.operator_banner_content) {
			this.hideElement(this.fields.operator_banner_holder);
			this.fields.operator_banner_content.innerHTML = '';

			const operator_banners = this.getOperatorBanners(operator);
			operator_banners.forEach((banner) => {
				if (this.fields.operator_banner_content) {
					this.showElement(this.fields.operator_banner_holder);
					this.fields.operator_banner_content.appendChild(banner.content);
				}
			});

			// show selected operator banner with all bundles
			Array.from(this.fields.operator_banner_content.getElementsByClassName('banner-content')).forEach((banner) => {
				if (parseInt(banner.getAttribute('data-operator_id')) === parseInt(operator.id)) {
					banner.classList.remove('d-none');
				} else {
					banner.classList.add('d-none');
				}
			});
		}
	}

	/**
	 * Adds banners to operators.
	 * @param {Object} 	operator
	 * @return {Object}
	 */
	getOperatorBanners(operator) {
		// console.log('MobileRecharge getOperatorBanners(%o)', operator);
		let operator_banners = [];

		if (operator.flags.banners) {
			for (let banner_type in operator.flags.banners) {
				if (operator.flags.banners.hasOwnProperty(banner_type)) {
					let banner_types = operator.flags.banners[banner_type];
					let valid_banner_type = true;
					let banner_track = {
						banner_type: '',
						banner_content: ''
					};

					banner_types.forEach((banner) => {
						let banner_icon;
						banner_icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
						banner_icon.classList.add('banner-icon', 'ml-5');
						banner_icon.setAttribute('data-banner_type', banner_type);

						let banner_message = document.createElement('div');
						banner_message.classList.add('banner-message', 'flex-grow-1');
						banner_message.innerHTML = banner.message;

						let banner_content = document.createElement('div');
						banner_content.classList.add('banner-content', 'mt-10');
						banner_content.setAttribute('data-operator_id', operator.id);
						banner_content.classList.add('d-none');

						if (typeof banner.terms !== 'undefined' && banner.terms !== '') {
							let unique_id = ((length) => {
								let result = '';
								let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
								let charactersLength = characters.length;
								for (let i = 0; i < length; i++) {
									result += characters.charAt(Math.floor(Math.random() * charactersLength));
								}
								return result;
							})(20);

							banner_content.setAttribute('data-toggle', 'collapse');
							banner_content.setAttribute('href', "#".concat(unique_id));
							banner_content.setAttribute('role', 'button');
							banner_content.setAttribute('aria-expanded', 'false');
							banner_content.setAttribute('aria-controls', 'collapseExample');

							let chevron = s.svg(
								'chevron-large-down',
								'0 0 24 24',
								['collapse-chevron', 'collapsed'],
								{},
								{},
								'',
								''
							);

							let banner_terms_holder = document.createElement('div');
							banner_terms_holder.classList.add('d-flex', 'align-items-center');
							banner_terms_holder.appendChild(banner_message);
							banner_terms_holder.innerHTML += chevron;

							let banner_terms = document.createElement('div');
							banner_terms.setAttribute('id', unique_id);

							if (banner.display_content) {
								if (banner.display_content ?? true) {
									banner_content.setAttribute('aria-expanded', 'true');
									banner_terms.classList.add('banner-terms', 'collapse', 'show');
								} else {
									banner_terms.classList.add('banner-terms', 'collapse');
								}
							} else {
								banner_terms.classList.add('banner-terms', 'collapse');
							}

							let banner_terms_wrapper = document.createElement('div');
							banner_terms_wrapper.classList.add('pt-10');
							banner_terms_wrapper.innerHTML = banner.terms;
							banner_terms.appendChild(banner_terms_wrapper);

							banner_content.appendChild(banner_terms_holder);
							banner_content.appendChild(banner_terms);
						} else {
							banner_content.appendChild(banner_message);
						}

						if (operator.country_code && operator.name && banner.message) {
							banner_track.banner_content = `${operator.country_code} - ${operator.name} - ${banner.message.substring(0, 20)}`;
						}

						switch (banner_type) {
							case '_index_mr_offer':
							case '_index_mr_operator_offer':
								if (banner.promotion_bubble ?? false) {
									banner_icon.innerHTML += '<use xlink:href="#svg_icon-label--promo-new"></use>';
								} else {
									banner_icon = null;
								}
								banner_track.banner_type = 'Offer';
								break;

							case '_index_mr_offer_middle':
								banner_icon.innerHTML += '<use xlink:href="#svg_icon-label--promo-new"></use>';
								banner_track.banner_type = 'Offer Middle';
								break;

							case '_index_mr_promo':
								banner_icon.innerHTML += '<use xlink:href="#svg_icon-label--promo-new"></use>';
								banner_track.banner_type = 'Promo';
								break;

							case '_mr_notice':
								banner_icon.innerHTML += '<use xlink:href="#svg_icon-label--notice"></use>';
								banner_content.classList.add('banner-content-icon');
								banner_content.insertAdjacentHTML('afterbegin', '<svg viewBox="0 0 24 24"><use xlink:href="#icon-various--info"></use></svg>');
								banner_track.banner_type = 'Notice';
								break;

							case '_mr_new_operator':
								banner_icon.innerHTML += '<use xlink:href="#svg_icon-label--new"></use>';
								banner_track.banner_type = 'New operator';
								break;

							case '_mr_message':
								if (banner.promotion_bubble ?? false) {
									banner_icon.innerHTML += '<use xlink:href="#svg_icon-label--promo-new"></use>';
								} else {
									banner_icon = null;
								}
								banner_content.classList.add('banner-content-icon');
								banner_content.insertAdjacentHTML('afterbegin', '<svg viewBox="0 0 24 24"><use xlink:href="#icon-various--info"></use></svg>');
								banner_track.banner_type = 'Message';
								break;

							case '_kc_mr_operator_offer':
								if (banner.message_type === 'text') {
									banner_content.classList.add('banner-content-icon');
									banner_content.insertAdjacentHTML('afterbegin', '<svg viewBox="0 0 24 24"><use xlink:href="#icon-various--info"></use></svg>');
								}

								if (banner.promotion_icon ?? false) {
									banner_icon.innerHTML = this.getPromotionIcon(banner.promotion_icon);
								} else {
									banner_icon = null;
								}

								banner_track.banner_type = 'Offer';
								break;

							default:
								valid_banner_type = false;
						}

						if (valid_banner_type) {
							operator_banners.push({
								'icon': banner_icon,
								'content': banner_content
							});
							this.options.tracking_params.banners[operator.id] = banner_track;
						}
					});
				}
			}
		}

		return operator_banners;
	}

	/**
	 * Create the operator account fields.
	 */
	createAccountFieldsSection() {
		// console.log('MobileRecharge createAccountFieldsSection(%o)', this.state.supplier_operator_fields);
		if (this.state.supplier_operator_fields.length) {
			this.showElement(this.fields.account_fields_holder);
			this.emptyElement(this.fields.account_fields_content);

			this.state.supplier_operator_fields.forEach((field, index) => {
				let field_wrapper = document.createElement('div');
				let field_heading = document.createElement('h3');
				let field_label = document.createElement('label');
				let field_input_group = document.createElement('div');
				let field_input_prepend;
				let field_input_prefix;
				let field_input = document.createElement('input');
				let field_input_append;
				let field_mask;
				let field_error;

				field_wrapper.classList.add('field-wrapper');
				if (index > 0) {
					field_wrapper.classList.add('mt-20');
				}

				field_label.classList.add('mb-0');
				field_label.textContent = field.label;
				field_label.setAttribute('for', field.field_key);

				field_input_group.classList.add('input-group');

				field_input.id = field.field_key;
				field_input.classList.add('field-input', 'form-control');
				field_input.name = `account_fields[][${field.name}]`;
				field_input.autocomplete = 'off';
				field_input.setAttribute('data-account-field-key', field.field_key);

				if (this.location === 'send_page') {
					field_input.classList.add('input-white');
				}

				if (field.placeholder) {
					field_input.placeholder = s.it(field.placeholder);
				}

				if (parseInt(field.required)) {
					field_input.required = true;
					field_input.setAttribute('aria-required', 'true');
					field_input.setAttribute('aria-invalid', 'true');
				}

				// handle display checkmark
				if (parseInt(field.required)) {
					field_input_append = document.createElement('div');
					field_input_append.classList.add('input-group-append');

					const field_input_checkmark = document.createElement('img');
					field_input_checkmark.classList.add('field-checkmark', 'form-control');
					field_input_checkmark.src = s.url('/images/svg_icons/Icon-checkmark-simple.svg');
					field_input_checkmark.style.backgroundColor = '#73B143';
					field_input_checkmark.classList.add('d-none');
					field_input_append.appendChild(field_input_checkmark);
				}

				// handle display error
				if (field.error_message) {
					field_error = document.createElement('div');
					field_error.classList.add('field-error', 'alert', 'alert-danger', 'text-center', 'mt-10', 'd-none');
				}

				switch (field.type) {
					case 'phone':
						field_input_group.setAttribute('dir', 'ltr');

						field_input.type = 'tel';
						field_input.autocomplete = 'tel';
						field_input.setAttribute('maxlength', '30');

						// handle display phone prefix
						field_input_prepend = document.createElement('div');
						field_input_prefix = document.createElement('div');
						field_input_prepend.classList.add('input-group-prepend');
						field_input_prefix.classList.add('input-group-text');
						field_input_prefix.textContent = field.prefix;
						field_input_prepend.appendChild(field_input_prefix);

						// handle display phone mask
						field_mask = document.createElement('small');
						field_mask.classList.add('field-mask', 'form-text', 'text-muted');
						if (this.location === 'send_page') {
							field_mask.classList.remove('text-muted');
							field_mask.classList.add('text-white');
						}
						field_mask.textContent = this.formatPhoneExample('');
						break;

					case 'string':
						field_input_group.setAttribute('dir', 'ltr');

						field_input.type = 'text';

						// handle display string mask
						field_mask = document.createElement('small');
						field_mask.classList.add('field-mask', 'form-text', 'text-muted');
						if (this.location === 'send_page') {
							field_mask.classList.remove('text-muted');
							field_mask.classList.add('text-white');
						}
						field_mask.textContent = this.formatStringExample('');
						break;

					case 'email':
					case 'nauta':
						field_input_prepend = '';
						field_input.type = 'email';
						field_input.autocomplete = 'email';
						break;

					default:
						field_input_prepend = '';
						field_input_append = '';
						field_input.type = 'text';
						break;
				}

				field_heading.append(field_label);

				field_input_prepend && field_input_group.appendChild(field_input_prepend);
				field_input_group.appendChild(field_input);
				field_input_append && field_input_group.appendChild(field_input_append);

				field_wrapper.appendChild(field_heading);
				field_wrapper.appendChild(field_input_group);

				field_mask && field_wrapper.appendChild(field_mask);
				field_error && field_wrapper.appendChild(field_error);

				this.fields.account_fields_content.appendChild(field_wrapper);
			});

			this.fields.account_fields_holder.classList.add('mb-40');
		} else {
			this.fields.account_fields_holder.classList.remove('mb-40');
			this.resetFields();
		}
	}

	/**
	 * Handles update of phone mask.
	 * @param {Object} 	field_mask
	 * @param {String} 	full_phone_number
	 */
	updatePhoneMask(field_mask, full_phone_number) {
		if (field_mask) {
			field_mask.innerHTML = this.formatPhoneExample(full_phone_number);
		}
	}

	/**
	 * Handles update of string mask.
	 * @param {Object} 	field_mask
	 * @param {String} 	full_string
	 */
	updateStringMask(field_mask, full_string) {
		if (field_mask) {
			field_mask.innerHTML = this.formatStringExample(full_string);
		}
	}

	/**
	 * Strip all non-numeric characters from string.
	 * @param {String} 	string
	 */
	stripNonNumericCharacters(string) {
		return string.replace(/\D/g, '');
	}

	/**
	 * Strip by dynamic regular expression from string.
	 * eg: [0-9a-z] - square brackets are required, otherwise does not apply
	 * @param {String} 	string
	 * @param {String} 	field_check_regex
	 */
	sanitizeByRegex(string, field_check_regex) {
		if ( -1 !== field_check_regex.indexOf('[') ) {
			field_check_regex = field_check_regex.replace(/[\^\$]/g, '');
			field_check_regex = field_check_regex.replace('[', '[^');
			let check_regex = new RegExp(field_check_regex, 'g');

			string = string.replace(check_regex, '');
		}

		return string;
	}

	/**
	 * Sanitize phone number.
	 * @param {String} 	phone_number
	 */
	sanitizePhoneNumber(phone_number) {
		return phone_number
			.replace(/[^+0-9]/, '')
			.replace(/\^/, '')
			.replace(/]/, '');

	}

	/**
	 * Sanitize email address.
	 * @param {String} 	email_address
	 */
	sanitizeEmailAddress(email_address) {
		return email_address.replace(/[^a-zA-Z0-9_.@-]+/g, '');
	}

	/**
	 * Formats phone number to include the country phone prefix.
	 * @param {String} 	phone_number
	 * @return {String}
	 */
	formatPhoneExample(phone_number) {
		// console.log('MobileRecharge formatPhoneExample(%o)', phone_number);
		let prefix = '';
		let new_number_mask = '';

		const phone_field = this.state.supplier_operator_fields.find((field) => field.type === 'phone');

		if (phone_field.prefix) {
			prefix = this.sanitizePhoneNumber(phone_field.prefix);
		}

		new_number_mask = this.formatExampleMask(
			phone_field,
			phone_number,
			prefix,
			'sanitizePhoneNumber'
		);

		return `${prefix}-${new_number_mask}`;
	}

	/**
	 * Formats string to include the prefix.
	 * @param {String} 	string
	 * @return {String}
	 */
	formatStringExample(string) {
		// console.log('MobileRecharge formatStringExample(%o)', string);
		let prefix = '';
		let new_string_mask = '';

		const string_field = this.state.supplier_operator_fields.find((field) => field.type === 'string');

		new_string_mask = this.formatExampleMask(
			string_field,
			string,
			prefix,
			false
		);
		prefix += prefix ? '-' : '';

		return `${prefix}${new_string_mask}`;
	}

	formatExampleMask(field, field_value, prefix, sanitizeFunction) {
		let extra_numbers = '';
		let new_field_mask = '';

		if (field.mask) {
			new_field_mask = field.mask
				.replace(field.prefix, '')
				.replace(/-/gi, '')
				.replace(/[x_]/gi, '#')
				.replace(/[0-9]\?/gi, '#')
				.replace(/\[\^[0-9]]/gi, '#');
		}

		if (field_value && new_field_mask) {
			field_value = sanitizeFunction
				? this[sanitizeFunction](field_value).replace(prefix, '')
				: field_value.replace(prefix, '');
			if (field_value.length > new_field_mask.length && new_field_mask.length) {
				let extra_numbers_span = document.createElement('span');
				extra_numbers_span.classList.add('color-danger');
				extra_numbers_span.innerHTML = field_value.substring(new_field_mask.length, field_value.length);
				extra_numbers = extra_numbers_span.outerHTML;
				field_value = field_value.substring(0, new_field_mask.length);
			}
			new_field_mask = field_value + new_field_mask.substring(field_value.length) + extra_numbers;
		}

		return new_field_mask;
	}

	/**
	 * Update the submit error message.
	 */
	updateSubmitMessage() {
		let track_event_category = 'Page Message';
		let track_event_action = 'Buy MR Error Message';
		let track_event_label = '';

		if (this.location === 'send_page') {
			track_event_action = 'Send MR Error Message';
		}

		if (!this.state.country.code) {
			track_event_label = 'PLEASE_SELECT_COUNTRY_FIRST';
			s.track.event(
				`${track_event_category}`,
				`${track_event_action}`,
				`${track_event_label}`
			);
			this.fields.submit_message_holder.textContent = s.it(track_event_label);
			throw new Error(s.it(track_event_label));
		}

		if (!this.state.operator.id) {
			track_event_label = 'MR_ERROR_MESSAGE_SELECT_OPERATOR';
			s.track.event(
				`${track_event_category}`,
				`${track_event_action}`,
				`${track_event_label}`
			);
			this.fields.submit_message_holder.textContent = s.it(track_event_label);
			throw new Error(s.it(track_event_label));
		}

		if (this.state.account_fields.keys.length) {
			this.state.account_fields.keys.forEach((key) => {
				const field_input = this.fields.account_fields_content.querySelector(`input[data-account-field-key='${key}']`);
				const field_is_invalid = field_input.getAttribute('aria-invalid') === 'true';
				const field = this.state.account_fields[key];

				if (field_is_invalid) {
					// TODO for track_event_label maybe use a placeholder for the field type
					switch (field.type) {
						case 'phone':
							track_event_label = 'ERROR_TRACK_EVENT_LABEL_PHONE';
							break;
						case 'email':
							track_event_label = 'ERROR_TRACK_EVENT_LABEL_EMAIL';
							break;
						case 'nauta':
							track_event_label = 'ERROR_TRACK_EVENT_LABEL_NAUTA';
							break;
						default:
							track_event_label = 'ERROR_TRACK_EVENT_LABEL_DEFAULT';
					}
					s.track.event(
						`${track_event_category}`,
						`${track_event_action}`,
						`${track_event_label}`
					);

					this.changeAccountField(field.field_key, field_input.value);
					this.fields.submit_message_holder.textContent = s.it(track_event_label);
					throw new Error(s.it(track_event_label));
				}
			});
		}

		if (this.location === 'buy_mr') {
			if (this.checkEmptyObject(this.state.amount)) {
				track_event_label = 'SELECT_AMOUNT_SEND';
				s.track.event(
					`${track_event_category}`,
					`${track_event_action}`,
					`${track_event_label}`
				);
				this.fields.submit_message_holder.textContent = s.it(track_event_label);
				throw new Error(s.it(track_event_label));
			}
		}
	}

	/**
	 * Sorts elements by priority.
	 * @param {Object|Array} elements
	 * @return {Number}
	 */
	sortByPriority(elements) {
		elements.sort((a, b) => {
			if (typeof a.priority === 'undefined') {
				a.priority = 0;
			}
			if (typeof b.priority === 'undefined') {
				b.priority = 0;
			}
			if (a.priority < b.priority) {
				return 1;
			}
			if (a.priority > b.priority) {
				return -1;
			}
			return 0;
		});
	}

	/**
	 * Resets fields data.
	 */
	resetFields() {
		if (this.location === 'buy_mr' || this.location === 'send_page') {
			try {
				this.hideElement(this.fields.operator_banner_holder);
				this.emptyElement(this.fields.operator_banner_content);
				this.hideElement(this.fields.account_fields_holder);
				this.emptyElement(this.fields.account_fields_content);
				this.hideElement(this.fields.amount_holder);
				this.hideElement(this.fields.amount_banner_holder);
				this.emptyElement(this.fields.amount_content);
				this.hideElement(this.fields.notify_holder);

				if (this.fields.submit_button) {
					this.fields.submit_button.classList.add('disabled');
				}
			} catch (error) {
				console.error('Error on resetFields', error);
			}
		}
	}

	/**
	 * Empty DOM element.
	 * @param {Object} element
	 */
	emptyElement(element) {
		if (element) {
			element.innerHTML = '';
		}
	}

	/**
	 * Hide DOM element.
	 * @param {Object} element
	 */
	hideElement(element) {
		if (element) {
			element.classList.remove('d-flex', 'd-block');
			element.classList.add('d-none');
		}
	}

	/**
	 * Show DOM element.
	 * @param {Object} element
	 */
	showElement(element) {
		if (element) {
			element.classList.remove('d-none');
		}
	}

	/**
	 * Checks if an object is empty.
	 * @param {Object} obj
	 * @return {Boolean}
	 */
	checkEmptyObject(obj) {
		for (const prop in obj) {
			if (obj.hasOwnProperty(prop)) {
				return false;
			}
		}
		return true;
	}

	/**
	 * Performs a scroll to a specific selector.
	 * @param {String} 	selector
	 * @return {Boolean}
	 */
	scrollToTarget(selector) {
		const target = document.querySelector(selector);
		if (target) {
			const navbar = document.querySelector('.navbar-kc');
			const navbar_info = navbar.getBoundingClientRect();
			const target_info = target.getBoundingClientRect();
			const offset = target_info.top - navbar_info.height;

			if (target_info.top >= 0 && target_info.bottom <= window.innerHeight) {
				// Element is in the viewport, no need to scroll
				return false;
			} else {
				window.scrollBy(0, offset);
				return true;
			}
		}
	}

	/*
	 * Check type of promotion icon
	*/
	getPromotionIcon(promotionIcon) {
		if(!promotionIcon) {
			return null;
		}
		switch (promotionIcon) {
			case 'speaker':
				return '<use xlink:href="#svg_icon-label--promo-new"></use>';
			case 'info':
				return '<use xlink:href="#svg_icon-label--notice"></use>';
			case 'new':
				return '<use xlink:href="#svg_icon-label--new"></use>';
			default:
				return null;
		}
	}
}
